module.exports = __webpack_public_path__ + "img/light RGB.e9c32105.png";